import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { services } from '../data/mockData';
import { HandHeart, Footprints } from 'lucide-react';

const PiedsMains = () => {
  const navigate = useNavigate();

  const handleReserve = (serviceName) => {
    navigate(`/reservation?service=${encodeURIComponent(serviceName)}`);
  };

  return (
    <div className="page-service">
      {/* Hero Header */}
      <section className="service-hero">
        <div className="service-hero-pattern" />
        <div className="service-hero-content">
          <h1 className="service-hero-title">Mes Prestations</h1>
          <p className="service-hero-subtitle">Beauté des Pieds & Mains</p>
          <p className="service-hero-description">
            Soins naturels et traditionnels pour sublimer vos pieds et vos mains
          </p>
        </div>
      </section>

      {/* Services List */}
      <section className="service-list-section">
        <div className="container-service">
          {services.piedsMains.map((service, index) => (
            <div key={service.id} className="service-item pieds-mains-item">
              <div className="service-item-icon-large">
                {service.icon === 'feet' ? (
                  <Footprints size={48} strokeWidth={1.5} />
                ) : (
                  <HandHeart size={48} strokeWidth={1.5} />
                )}
              </div>
              
              <div className="service-item-content">
                <h2 className="service-item-title">{service.name}</h2>
                <h3 className="service-item-subtitle">{service.subtitle}</h3>
                <p className="service-item-description">{service.description}</p>
                <button
                  onClick={() => handleReserve(service.name)}
                  className="btn-reserve-service"
                  style={{marginTop: '1rem'}}
                >
                  Réserver
                </button>
              </div>
              
              <div className="service-item-price">
                <div className="price-badge">
                  <span className="price-amount">{service.price}€</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Info Section */}
      <section className="info-section">
        <div className="container-service">
          <div className="info-card">
            <h3 className="info-title">Disponibles à partir du 25 avril</h3>
            <div className="info-features">
              <div className="info-feature">
                <span className="info-icon">🌿</span>
                <span>Produits Naturels</span>
              </div>
              <div className="info-feature">
                <span className="info-icon">🪷</span>
                <span>Soins Doux et Respectueux</span>
              </div>
              <div className="info-feature">
                <span className="info-icon">💚</span>
                <span>Bien-Être Garanti</span>
              </div>
              <div className="info-feature">
                <span className="info-icon">✨</span>
                <span>Résultats Naturels & Durables</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="service-cta">
        <div className="service-cta-content">
          <h3 className="service-cta-title">Envie de sublimer vos pieds et vos mains ?</h3>
          <p className="service-cta-text">
            RDV en privé ou dans le lien dans ma bio
          </p>
          <Link to="/reservation" className="btn-primary">
            Réserver maintenant
          </Link>
        </div>
      </section>
    </div>
  );
};

export default PiedsMains;
